import { defineStore } from 'pinia'
import storage from '@/plugins/storage'
import http from '@/plugins/api.js'

const authUrl = window.config ? window.config.authUrl : ''

// this should be an api call but for now we just hard code
const PAGE_PERMISSIONS = {
  '/login': [
    1,
    2,
    3,
    4,
    6,
    5
  ],
  '/admin': [
    1,
    2,
    3,
    6
  ],
  '/configuration': [
    1,
    2,
    3,
    6
  ],
  '/users': [
    1,
    2
  ],
  '/storage': [
    1,
    2
  ],
  '/locations': [
    1,
    2,
    3,
    4,
    6
  ],
  '/contacts': [
    1,
    2
  ],
  '/insurance': [
    1,
    2,
    3,
    4,
    6,
    5
  ],
  '/dashboard': [
    1,
    2,
    3,
    4,
    6
  ],
  '/testdrives': [
    1,
    2,
    3,
    4,
    6,
    5
  ]
}

const SESSION_TOKEN_NAME = 'auth/token'
const SESSION_USER_PROFILE = 'auth/profile'

export const auth = defineStore('auth', {
  id: 'auth',
  state: () => ({
  token:  storage.session.getItem(SESSION_TOKEN_NAME),
  passthrough: '',profile: JSON.parse(storage.session.getItem(SESSION_USER_PROFILE)),
  noVideo:true
  }),
  actions: {
    clearToken() {
        this.roles = null
        this.token = null
        this.username = null
        storage.session.clear()
      },
      setPassthrough(passthrough) {
        this.passthrough = passthrough
      },
      async getToken(user, pwd) {
        console.log('reached')
        const t = await http.post('getToken', { username: user, password: pwd }, {}, authUrl)
        
        this.token = t.data
        storage.session.setItem(SESSION_TOKEN_NAME, t.data)
        
        var base64Url = t.data.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))
        var tokenPayload = JSON.parse(jsonPayload)
        this.profile = {
          user: parseInt(tokenPayload.uid),
          contact: parseInt(tokenPayload.cid),
          firm: parseInt(tokenPayload.fid),
          timezone: parseInt(tokenPayload.tz),
          countryID:parseInt(tokenPayload.bci),
          firstName: tokenPayload.fname,
          lastName: tokenPayload.lname,
          username: tokenPayload.uname,
          email: tokenPayload.email,
          language: tokenPayload.cc,
          roles: []
        }
        for (let i = 0; i < tokenPayload.rid.length; i++) {
            this.profile.roles.push(parseInt(tokenPayload.rid[i]))
        }
        storage.session.setItem(
          SESSION_USER_PROFILE,
          JSON.stringify(this.profile)
        )
        this.getNoVideo()
      },
      isAllowed(page) {
        if (!PAGE_PERMISSIONS[page]) {
          return true
        }
        if (this.profile.roles && this.profile.roles.length) {
          return this.profile.roles.some((r) => PAGE_PERMISSIONS[page].includes(r))
        }
        return PAGE_PERMISSIONS[page].includes('Guest')
        },
        async getNoVideo(){
          const t = await http.get(`firm/firm?firm=${this.profile.firm}`)
          this.noVideo = t.data.noVideo
        }
  }
})
